import { PlanogramViewer } from "@labeling-tools/ui-components/src/planogram-viewer/planogram-viewer.comp";
import { Select } from "@mantine/core";
import { JobTaskDetailSchema } from "@augmodo/lebron-browser-client";
import { useAtlasPlanograms } from "@labeling-tools/api/hooks";
import { useAtlasStores } from "@labeling-tools/api/hooks/atlas/useAtlasStores";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { setSelectedPlanogramId } from "@/store";

export const ProductAssociationPlanogram = ({
  task,
}: {
  task: JobTaskDetailSchema;
}) => {
  const dispatch = useAppDispatch();
  const selectedPlanogramId = useAppSelector(
    (state) => state.productAssociation.selectedPlanogramId
  );
  const handlePlanogramFilterChange = (value: string | null) => {
    dispatch(setSelectedPlanogramId(value));
  };
  const { data: stores } = useAtlasStores(task?.data?.store_id);
  const { data: planograms } = useAtlasPlanograms(stores?.stores[0].id);

  if (!task?.data?.store_id) return null;
  return (
    <div>
      <div className="mb-4 flex justify-center">
        <Select
          placeholder="Select a planogram"
          value={selectedPlanogramId}
          onChange={handlePlanogramFilterChange}
          data={planograms?.planograms.map((planogram) => ({
            value: planogram.id || "",
            label: planogram.description || "",
          }))}
          clearable
          size="md"
          searchable
          w={400}
        />
      </div>
      <PlanogramViewer
        planogram_id={selectedPlanogramId || ""}
        // onSelectProduct={() => {}}
      />
    </div>
  );
};
